<template>
  <label :for="`input-${inputId}`" class="form-label" v-if="inputLabel">
    {{inputLabel}}
    <span v-if="requiredFlag">*</span>
  </label>
  <div class="input-group">
    <span class="input-group-text" v-if="frontGroup">
      {{ frontGroup }}
    </span>
    <slot />
    <span class="input-group-text" v-if="backGroup">
      {{ backGroup }}
    </span>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { v4 as uuid } from 'uuid';

  import BaseInput from './BaseInput.vue';

  export default defineComponent({
    components: {
      BaseInput,
    },
    props: {
      backGroup: {
        type: String,
        required: false,
      },
      frontGroup: {
        type: String,
        required: false,
      },
      requiredFlag: {
        type: Boolean,
        required: false,
        default: false,
      },
      inputLabel: {
        type: String,
        required: false,
        default: '',
      },
    },
    setup(_, { emit }) {
      const inputId = uuid();

      const emitValue = (event: any) => {
        emit('update:modelValue', event.target ? event.target.value : '');
      };

      return { inputId, emitValue };
    },
  });
</script>

<style scoped></style>
